import React from 'react';
import { Tooltip } from 'antd';

const FitScoreTooltip = ({ fitScore, fitReasons, name, children }) => {
	if (fitScore == null) return children;

	const color = fitScore >= 80 ? '#2f9b2c' : fitScore >= 50 ? '#ff9800' : '#f8532b';

	const content = (
		<div className="fit-score-tooltip">
			<div style={{ fontWeight: 600, marginBottom: 4 }}>{name} — {fitScore}%</div>
			{fitReasons && fitReasons.map((reason, i) => (
				<div key={i} style={{ fontSize: 11, padding: '1px 0', color: '#ddd' }}>• {reason}</div>
			))}
		</div>
	);

	return (
		<Tooltip title={content} placement="right" overlayStyle={{ maxWidth: 280 }}>
			<span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
				{children}
				<span style={{
					fontSize: 11,
					fontWeight: 600,
					color,
					minWidth: 28,
					textAlign: 'right',
				}}>
					{fitScore}%
				</span>
			</span>
		</Tooltip>
	);
};

export default FitScoreTooltip;
